import SEO from "../components/SEO";
import seoData from "../seoData";
import BreadcrumbSchema from "../components/BreadcrumbSchema";
import { Gallery } from "../components/gallery";
import JsonData from "../data/data.json";

const GalleryPage = () => (
  <>
    {/* SEO Meta */}
    <SEO {...seoData.gallery} />
    <BreadcrumbSchema
        items={[
            { name: "Home", url: "/" },
            { name: "Gallery", url: "/gallery" },
        ]}
    />
    <Gallery data={JsonData.Gallery} />
  </>
);

export default GalleryPage;
